<template>
  <v-container>
    <v-row justify="space-around" align="center">
      <v-col cols="12" class="text-center">
        <h1>Upload Your Manifest</h1>
      </v-col>
    </v-row>

    <v-row justify="center" align="center">
      <v-col cols="12" md="6">
        <v-autocomplete
          label="Choose a region..."
          :items="regions"
          item-text="name"
          return-object
          v-model="propsHeader.region"
          prepend-icon="fas fa-map"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row justify="center" align="center">
      <v-col cols="12" md="3"  v-if="isInternalUser">
        <v-switch
                  class="justify-center"
                  color="blue"
                  v-model="dateOverrideSwitch"
                  label="Override date"
        ></v-switch>
      </v-col>
      <v-col
        :class="[isInternalUser ? (dateOverrideSwitch ? 'col-12 col-md-3' : 'col-12 col-md-4') : 'col-12 col-md-6']">
        <v-menu
          v-model="date_menu"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="propsHeader.date"
              readonly
              prepend-icon="fas fa-calendar"
              label="Delivery Date"
              @click.native="date_menu = true"
            ></v-text-field>
          </template>
          <v-date-picker v-model="propsHeader.date" @input="date_menu=false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" v-if="isInternalUser && dateOverrideSwitch">
        <v-menu
          v-model="original_date_menu"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="propsHeader.original_date"
              readonly
              prepend-icon="fas fa-calendar"
              label="Original Date"
              @click.native="original_date_menu = true"
            ></v-text-field>
          </template>
          <v-date-picker v-model="propsHeader.original_date" @input="original_date_menu=false"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <transition name="slide-x-transition">
      <v-row justify="center" align="center">
        <v-col cols="12" md="3" v-if="showClient && showFields">
          <v-autocomplete
            label="Choose Client..."
            :items="clients"
            item-text="name"
            return-object
            v-model="propsHeader.client"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" v-if="showService">
          <v-autocomplete
            label="Choose Service..."
            :items="services"
            item-text="name"
            return-object
            v-model="propsHeader.service"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" v-if="showFields">
          <v-select
            label="Choose a Time Window"
            item-text="name"
            return-object
            :items="timeWindows"
            v-model="propsHeader.time_window"
          >
          </v-select>
        </v-col>
      </v-row>
    </transition>

    <v-row justify="space-around" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">

      <transition name="slide-x-transition">
        <v-col cols="10" md="3" v-if="showFields">
          <v-switch
            class="justify-center"
            style="align-items: center"
            color="blue"
            v-model="sitesOnlySwitch"
            :label="sitesOnlySwitch ? 'Sites Only' : 'Import Deliveries'"
          ></v-switch>
        </v-col>
      </transition>

      <transition name="slide-x-transition" v-if="overridePermission">
        <v-col cols="10" md="3" v-if="showFields">
          <v-switch
            class="justify-center"
            style="align-items: center"
            color="blue"
            v-model="overrideSwitch"
            :label="overrideSwitch ? 'Ignore Cut Off' : 'Enforce Cut Off'"
          ></v-switch>
        </v-col>
      </transition>

      <transition name="slide-x-transition" v-if="samedayPermission">
        <v-col cols="10" md="3" v-if="showFields">
          <v-switch
            class="justify-center"
            style="align-items: center"
            color="blue"
            v-model="samedaySwitch"
            :label="samedaySwitch ? 'Ignore WMS CutOff' : 'Enforce WMS CutOff'"
          ></v-switch>
        </v-col>
      </transition>

      <transition name="slide-x-transition" v-if="adminPermission">
        <v-col cols="10" md="3" v-if="showFields">
          <v-switch
            class="justify-center"
            style="align-items: center"
            color="blue"
            v-model="adminSwitch"
            :label="adminSwitch ? 'Admin mode' : 'User mode'"
          ></v-switch>
        </v-col>
      </transition>


    </v-row>

    <v-row justify="center" v-if="showFields">
      <v-col cols="12" md="4" class="text-center">
        <v-btn text @click="$refs.manifest.click()" color="warning" block>
          <div v-if="file===''">Select Your Manifest</div>
          <div v-else>{{this.file.name}}</div>
        </v-btn>
        <input v-show="false" ref="manifest" type="file" @change="handleFileUpload">
      </v-col>
      <v-col cols="12" md="4" class="text-center">
        <v-btn text block color="blue darken-1" @click="submitFile()">
          <v-icon class="mr-2">cloud_upload</v-icon>
          UPLOAD
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import axios from 'axios'
    // @vuese
    // Header for the UploadYourManifest page.
    // @group Manifest
    export default {
        name: "ManifestUploaderHeader",
        props: {
            propsHeader: Object,
        },
        data() {
            return {
                date_menu: false,
                original_date_menu: false,
                file: '',
                sitesOnlySwitch: false,
                overrideSwitch: false,
                dateOverrideSwitch: false,
                adminSwitch: false,
                samedaySwitch:false
            }
        },
        methods: {
            // @vuese
            // Handles file upload once a file is selected in the input field of this page.
            handleFileUpload() {
                this.file = this.$refs.manifest.files[0];
                this.$store.commit('displaySnackbar', 'File Loaded');
            },
            // @vuese
            // Fills a FormData variable with the uploaded manifest information and post this FormData on the API.
            submitFile() {
                let manifestFormData = new FormData();

                if (this.propsHeader.region !== null && this.propsHeader.date !== null
                    && this.propsHeader.time_window !== null && this.propsHeader.client !== null
                    && this.propsHeader.service !== null) {

                    manifestFormData.set('region', this.propsHeader.region.id);
                    manifestFormData.set('date', this.propsHeader.date);
                    if (this.propsHeader.original_date !== null) {
                        manifestFormData.set('original_date', this.propsHeader.original_date);
                    }
                    manifestFormData.set('client', this.propsHeader.client.id);
                    manifestFormData.set('default_time_window', this.propsHeader.time_window.id);
                    manifestFormData.set('default_service', this.propsHeader.service.id);
                    manifestFormData.set('sites_only', this.sitesOnlySwitch);
                    manifestFormData.set('ignore_cutoff', this.overrideSwitch);
                    manifestFormData.set('admin_override', this.adminSwitch);
                    manifestFormData.set('same_day', this.samedaySwitch);
                    manifestFormData.append('manifest', this.file);


                    axios({
                        method: 'post',
                        url: process.env.API_URL + '/manifests/upload',
                        data: manifestFormData,
                        config: {
                            headers: {
                                'Content-Type':
                                    'multipart/form-data'
                            }
                        }
                    })
                        .then((response) => {
                            this.$emit('manifest-submitted', response.data.job_id);
                        })
                        .catch((response) => {
                            // console.log(response.response.data.error);
                            this.$emit('alert', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    this.$emit('alert', 'Please fill all the fields to upload your manifest');
                }

            },
        },
        computed: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            regions() {
                return this.$store.getters['auth/permissionRegions']('manifest_process');
            },
            // @vuese
            // Returns a boolean saying if we should show the timewindow and client field.
            showFields() {
                if (this.propsHeader.date !== null && this.propsHeader.region !== null) {
                    return true
                } else {
                    return false
                }
            },
            showClient() {
                if (this.clients === null) return false;
                return (this.isInternalUser && this.showFields) || this.clients.length > 1;
            },
            showService() {
                if (this.services === null) return false;
                return this.services.length > 1;
            },
            // @vuese
            // Returns a boolean saying if we should show the ignore cut off switch
            overridePermission() {
                if (this.propsHeader.region !== null) {
                    return this.$store.getters['auth/hasPermissionRegionId']('delivery_violate_cutoffs', this.propsHeader.region.id);
                } else return false;
            },
            // @vuese
            // Returns a boolean saying if we should show the ignore same day cut off switch
            samedayPermission() {
              if (this.propsHeader.region !== null) {
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_violate_wms_cutoffs', this.propsHeader.region.id);
              } else return false;
            },
            // @vuese
            // Returns a boolean saying if we should show the admin override switch
            adminPermission() {
                return this.$store.getters['auth/hasPermission']('admin');
            }
        },
        asyncComputed: {
            // @vuese
            // Load clients for given region and date
            async clients() {
                console.log("Load Clients");
                this.propsHeader.client = null;
                return await axios.get(process.env.API_URL + '/clients')
                    .then(function (response) {
                        console.log("Got " + response.data.length + " clients");
                        if (response.data.length === 1) {
                            this.propsHeader.client = response.data[0];
                        }
                        return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    }.bind(this))
                    .catch((error) => {
                        console.log(error.response.error);
                    });
            },
            // @vuese
            // Gets all the time windows for a specific region and a specific client.
            async timeWindows() {
                console.log("Load Time Windows");
                if (this.propsHeader.date !== null && this.propsHeader.region !== null && this.propsHeader.client !== null && this.propsHeader.service !== null) {
                    this.propsHeader.time_window = null;
                    let date = this.propsHeader.date;
                    if (this.propsHeader.original_date !== null) {
                        date = this.propsHeader.original_date
                    }
                    return await axios.get(process.env.API_URL + '/regions/' + this.propsHeader.region.id + '/clients/' + this.propsHeader.client.id
                        + '/timewindows?show_all=true&date=' + date + '&service=' + this.propsHeader.service.id)
                        .then((response) => {
                            console.log("Got " + response.data.length + " time windows");
                            response.data.map((tw) => {
                                return tw.name = 'From ' + tw.time_start + ' - To ' + tw.time_end
                            });
                            if (response.data.length === 1) {
                                this.propsHeader.time_window = response.data[0];
                            }
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error.response.error)
                        });
                } else return [];
            },
            // @vuese
            // Gets all the services for a specific client.
            async services() {
                console.log("Load Services");
                if (this.propsHeader.client !== null) {
                    this.propsHeader.service = null;
                    return await axios.get(process.env.API_URL + '/clients/' + this.propsHeader.client.id
                        + '/services')
                        .then((response) => {
                            console.log("Got " + response.data.length + " services");
                            if (response.data.length === 1) {
                                this.propsHeader.service = response.data[0];
                            }
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error.response.error)
                        });
                } else return [];
            }
        },
        watch: {
            dateOverrideSwitch() {
                if (this.dateOverrideSwitch === false) {
                    this.original_date_menu = false;
                    this.propsHeader.original_date = null
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Manifest/ManifestUploaderHeader.vue